import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../dynamicFormBuilder/FormField'
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import { AlterAddressLayout,AddressLayoutForVisible } from "../common/Layouts";
import { CheckBox } from "devextreme-react";
let transportCarrier = null;
function AlternateAddressTab(props) {
    var accessToken = props.oidc.user.access_token;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    transportCarrier = props.formFields.R_TRANSPORTCARRIER;
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const [hideForm, setHideForm] = useState(false);

    const onFormLoad = () => {
    }
    const handleFieldValueChange = (e) => {
    }
    const handleSelectionChange = useCallback((name, e) => {

    }, []);
    useEffect(() => {
        if (props.formFields['DefAddress'] === false) {
            setHideForm(true);
        }
        else {
            setHideForm(false);
        }

    }, [props.formFields])
    return (
        <div className="FormMt">
            <CheckBox
                className="ml-3 mb-3"
                key={'DefAddress'}
                text={"Def Address"}
                value={props.formFields['DefAddress']??true}
                onValueChanged={(e) => {
                    props.setformFields(prevState => ({
                        ...prevState,
                        ['DefAddress']: e.value,
                        ['AlterAddressADDRESSNAME']: props.IdType==="01"?'Customer': props.IdType==="02" ? 'Consignee/Ship To': props.IdType==="03" ? 'Shipper': props.IdType==="04" ? 'Manufacturer': props.IdType==="05" ? 'Carrier/Ship Via' : props.IdType==="06" ? 'Warehouse': props.IdType==="07" ? 'Vendor': props.IdType==="08" ? 'Supplier': props.IdType==="09" ? 'Carrier': props.IdType==="10" ? 'Transport Carrier': props.IdType==="11" ? 'Agent': props.IdType==="12" ? 'Customs Broker': props.IdType==="13" ? 'Bank': props.IdType==="14" ? 'Freight Forwarder': props.IdType==="15" ? 'Other' : '',
                        ['AlterAddressNAME']: props.formFields.NAME,
                        ['AlterAddressADDRESS1']: '',
                        ['AlterAddressADDRESS2']: '',
                        ['AlterAddressCITY']: '',
                        ['AlterAddressZIP']: '',
                        ['AlterAddressCOUNTRY']: '',
                        ['AlterAddressTELEPHONE1']: '',
                        ['AlterAddressTELEPHONE2']: '',
                        ['AlterAddressFAX1']: '',
                        ['AlterAddressFAX2']: null,
                        ['AlterAddressMODEM1']: '',
                        ['AlterAddressMODEM2']: '',
                        ['AlterAddressCELLPHONE1']: null,
                        ['AlterAddressCELLPHONE2']: null,
                        ['AlterAddressPAGER1']: null,
                        ['AlterAddressPAGER2']: '',
                        ['AlterAddressEMAILADDRESS1']: '',
                        ['AlterAddressEMAILADDRESS2']: '',
                        ['AlterAddressWEBSITEADDRESS1']: '',
                        ['AlterAddressWEBSITEADDRESS2']: '',
                        ['AlterAddressSTATE']: '',
                        ['AlterAddressALTERNATENAME']: '',
                        ['AlterAddressLATITUDE']: '',
                        ['AlterAddressLONGITUDE']: '',
                        ['AlterAddressCOUNTY']: '',
                    }))
                }}
            >
            </CheckBox>
            {hideForm  && (
                <FormField
                    currrentUser={currentUser}
                    layoutId='F8D4AE59-E315-4B8E-A06B-C949767D43A2'
                    layoutName='AddressForm'
                    defaultFormSchema={AlterAddressLayout}
                    formFields={props.formFields}
                    setformFields={props.setformFields}
                    onFormLoad={onFormLoad}
                    handleFieldValueChange={handleFieldValueChange}
                    handleSelectedItemChange={handleSelectionChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={formRefs}
                    noSpacingBeforeFirstRow={true}
                />
            )}
            {!hideForm  && (
                <FormField
                    currrentUser={currentUser}
                    layoutId='E31FD914-F9EC-4D20-9C33-C42EBFF6FCF9'
                    layoutName='AddressForm'
                    defaultFormSchema={AddressLayoutForVisible}
                    formFields={props.formFields}
                    setformFields={props.setformFields}
                    onFormLoad={onFormLoad}
                    handleFieldValueChange={handleFieldValueChange}
                    handleSelectedItemChange={handleSelectionChange}
                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                    formRefs={formRefs}
                    noSpacingBeforeFirstRow={true}
                />
            )}
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(AlternateAddressTab);